import { ref } from 'vue';

import { defineStore } from 'pinia';

import { getDictionaryListApi } from '#/api';

const _dicList = [
  'payment_account_type',
  'recharge_type',
  'all_transaction_type',
  'distributor_transaction_type',
  'chargebacks_type',
  'label_type',
  'country_type',
  'track_type',
  'date_range_type',
  'risk_status_type',
  'order_status',
  'distributor_chargebacks_type',
  'sn_types',
  'service_account_type',
  'main_business_type',
  'coop_status_type',
  'distributor_recharge_type',
  'service_recharge_type',
  'service_chargebacks_type',
  'package_status_type',
  'sn_status_type',
  'account_status_type',
  'state_type',
  'md_info_status_type',
  'md_info_types',
  'tk_order_status',
  'order_type_list',
  'logistics_status',
  'proxy_mode_list',
  'shipping_label_list',
  'staging_order_status'
] as const;

type DicEnum = { [K in (typeof _dicList)[number]]: any[] };

export const useDicEnumStore = defineStore('dicEnum', () => {
  const loginLoading = ref(false);

  const dicEnum = ref<DicEnum>({
    payment_account_type: [],
    recharge_type: [],
    all_transaction_type: [],
    distributor_transaction_type: [],
    chargebacks_type: [],
    label_type: [],
    country_type: [],
    track_type: [],
    date_range_type: [],
    risk_status_type: [],
    order_status: [],
    distributor_chargebacks_type: [],
    sn_types: [],
    service_account_type: [],
    main_business_type: [],
    coop_status_type: [],
    distributor_recharge_type: [],
    service_recharge_type: [],
    service_chargebacks_type: [],
    package_status_type: [],
    sn_status_type: [],
    account_status_type: [],
    state_type: [],
    md_info_status_type: [],
    md_info_types: [],
    tk_order_status: [],
    order_type_list: [],
    logistics_status: [],
    proxy_mode_list: [],
    shipping_label_list:[],
    staging_order_status:[]
  });
  const localDicEnum = ref({
    order_type_list: [
      {
        label: '直发',
        value: 0,
      },
      {
        label: '中转仓',
        value: 1,
      },
    ],
    proxy_mode_list: [
      {
        label: '代采',
        value: 0,
      },
      {
        label: '自采',
        value: 1,
      },
    ],
    shipping_label_list:[
      {
        label: '自费面单',
        value: '2',
      },
      {
        label: '速蜂面单',
        value: '0',
      }
    ],
    have_shipping_label_list:[
      {
        label: '无',
        value: false,
      },
      {
        label: '有',
        value: true,
      }
    ],
    refund_status_list:[
      {
        label: '审核中',
        value: 0,
      },
      {
        label: '退货中',
        value: 1,
      },
      {
        label: '已完成',
        value: 2,
      },
      {
        label: '已取消',
        value: 3,
      },
      {
        label: '未通过',
        value: 4,
      }
    ]
  });
  async function getDictionaryList() {
    const serveDicEnum = await getDictionaryListApi();
    dicEnum.value = {
      ...dicEnum.value,
      ...localDicEnum.value,
      ...serveDicEnum,
    };
  }

  function findDictNameById(data: any[], value: number | string) {
    if (`${value}` === '') return '';
    if (Array.isArray(data)) {
      const curD = data.find((item) => item.type === value);
      return curD ? curD.name : '';
    }
  }
  function $reset() {
    loginLoading.value = false;
  }
  return {
    $reset,
    getDictionaryList,
    findDictNameById,
    dicEnum,
  };
});
